// Copyright © 2018 David Caldwell <david@porkrind.org>

var lib = require('./lib'), map=lib.map;
var prnt = require('./print'), sprintf=prnt.sprintf;

function append_alpha(c, a) {
    return a != void 0 ? c.concat(a) : c;
}

function rgb_from_hsl(hsl) { // From Golem, which was originally from wikipedia, I think.
    var [h, s, l, a] = [hsl[0], hsl[1]/100, hsl[2]/100, hsl[3]];

    var hsl_normalize = tc => (tc < 0 ? tc + 1 :
                               tc > 1 ? tc - 1 : tc);

    var hsl_color = tc => (tc < 1/6 ? p + ((q - p) * 6 * tc) :
                           tc < 1/2 ? q :
                           tc < 2/3 ? p + ((q - p) * (2/3 - tc) * 6) :
                           p)*255;

    var q = l < .5 ? l * (s+1) : l + s - (l * s);
    var p = 2 * l - q;
    var hk = h/360;
    var tr = hsl_normalize(hk + 1/3);
    var tg = hsl_normalize(hk);
    var tb = hsl_normalize(hk - 1/3);
    return append_alpha([hsl_color(tr), hsl_color(tg), hsl_color(tb)], a);
}

function hsl_from_rgb(rgb) { // https://en.wikipedia.org/wiki/HSL_and_HSV#Hue_and_chroma
    var a = rgb.length == 4 ? rgb.pop() : void 0;
    var [r, g, b] = map(n => n/255, rgb);

    var M = Math.max(r,g,b);
    var m = Math.min(r,g,b);
    var C = M-m;

    var H = Math.floor(60 * (C == 0 ?  0 :
                             M == r ?  (g-b)/C + 6 :
                             M == g ?  (b-r)/C + 2 :
                           /*M == b ?*/(r-g)/C + 4)) % 360;
    var L = (M+m)/2;
    var S = L == 1 || L == 0 ? 0 :
                               C / (1 - Math.abs(2*L - 1));

    return append_alpha([H, S*100, L*100], a);
}

function rgb_from_hex(hex)
{
    if (hex[0] == "#") hex = hex.substring(1);
    var h = parseInt(hex, 16);
    return (hex.length == 3) ? [h>>4 & 0xf0 | h>>8 & 0xf,
                                h>>0 & 0xf0 | h>>4 & 0xf,
                                h<<4 & 0xf0 | h>>0 & 0xf]
                             : [h>>16 & 0xff, h>>8 & 0xff, h>>0 & 0xff];
}

function hsl_from_hex(hex) {
    return hsl_from_rgb(rgb_from_hex(hex));
}

function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
}

function saturate_hsl(hsl) {
    var [h, s, l, a] = hsl;
    return [h % 360, clamp(s, 0, 100), clamp(l, 0, 100)].concat(a == void 0 ? [] : [clamp(a, 0, 100)]);
}

function saturate_rgb(rgb) {
    var [r, g, b, a] = rgb;
    return [clamp(r, 0, 255), clamp(g, 0, 255), clamp(b, 0, 255)].concat(a == void 0 ? [] : [clamp(a, 0, 100)]);
}

function add_color(a, b) {
    return [a[0]+b[0], a[1]+b[1], a[2]+b[2]].concat(a[3] || b[3] ? [(a[3] ? a[3] : 0) + (b[3] ? b[3] : 0)] : []);
}

function add_hsl(a, b) {
    return saturate_hsl(add_color(a,b));
}

function add_rgb(a, b) {
    return saturate_rgb(add_color(a,b));
}

function css_from_hsl(hsl) {
    var [h, s, l, a] = hsl;
    return a == void 0 ? `hsl(${h},${s}%,${l}%)` : `hsla(${h},${s}%,${l}%,${a}%)`;
}

function css_from_rgb(rgb) {
    var [r, g, b, a] = rgb;
    return a == void 0 ? `rgb(${r},${g},${b})` : `rgba(${r},${g},${b},${a}%)`;
}

function hex_from_rgb(rgb) {
    var [r, g, b] = rgb;
    return sprintf("#%02x%02x%02x", r, g, b);
}

function hex_from_hsl(hsl) {
    return hex_from_rgb(rgb_from_hsl(hsl));
}


module.exports = {
    rgb_from_hsl: rgb_from_hsl,
    hsl_from_rgb: hsl_from_rgb,
    rgb_from_hex: rgb_from_hex,
    hsl_from_hex: hsl_from_hex,
    css_from_rgb: css_from_rgb,
    css_from_hsl: css_from_hsl,
    hex_from_rgb: hex_from_rgb,
    hex_from_hsl: hex_from_hsl,
    add_hsl: add_hsl,
    add_rgb: add_rgb
}
// Copyright © 2018 David Caldwell <david@porkrind.org>

var lib = require('./lib'), map=lib.map;
var prnt = require('./print'), sprintf=prnt.sprintf;

function append_alpha(c, a) {
    return a != void 0 ? c.concat(a) : c;
}

function rgb_from_hsl(hsl) { // From Golem, which was originally from wikipedia, I think.
    var [h, s, l, a] = [hsl[0], hsl[1]/100, hsl[2]/100, hsl[3]];

    var hsl_normalize = tc => (tc < 0 ? tc + 1 :
                               tc > 1 ? tc - 1 : tc);

    var hsl_color = tc => (tc < 1/6 ? p + ((q - p) * 6 * tc) :
                           tc < 1/2 ? q :
                           tc < 2/3 ? p + ((q - p) * (2/3 - tc) * 6) :
                           p)*255;

    var q = l < .5 ? l * (s+1) : l + s - (l * s);
    var p = 2 * l - q;
    var hk = h/360;
    var tr = hsl_normalize(hk + 1/3);
    var tg = hsl_normalize(hk);
    var tb = hsl_normalize(hk - 1/3);
    return append_alpha([hsl_color(tr), hsl_color(tg), hsl_color(tb)], a);
}

function hsl_from_rgb(rgb) { // https://en.wikipedia.org/wiki/HSL_and_HSV#Hue_and_chroma
    var a = rgb.length == 4 ? rgb.pop() : void 0;
    var [r, g, b] = map(n => n/255, rgb);

    var M = Math.max(r,g,b);
    var m = Math.min(r,g,b);
    var C = M-m;

    var H = Math.floor(60 * (C == 0 ?  0 :
                             M == r ?  (g-b)/C + 6 :
                             M == g ?  (b-r)/C + 2 :
                           /*M == b ?*/(r-g)/C + 4)) % 360;
    var L = (M+m)/2;
    var S = L == 1 || L == 0 ? 0 :
                               C / (1 - Math.abs(2*L - 1));

    return append_alpha([H, S*100, L*100], a);
}

function rgb_from_hex(hex)
{
    if (hex[0] == "#") hex = hex.substring(1);
    var h = parseInt(hex, 16);
    return (hex.length == 3) ? [h>>4 & 0xf0 | h>>8 & 0xf,
                                h>>0 & 0xf0 | h>>4 & 0xf,
                                h<<4 & 0xf0 | h>>0 & 0xf]
                             : [h>>16 & 0xff, h>>8 & 0xff, h>>0 & 0xff];
}

function hsl_from_hex(hex) {
    return hsl_from_rgb(rgb_from_hex(hex));
}

function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
}

function saturate_hsl(hsl) {
    var [h, s, l, a] = hsl;
    return [h % 360, clamp(s, 0, 100), clamp(l, 0, 100)].concat(a == void 0 ? [] : [clamp(a, 0, 100)]);
}

function saturate_rgb(rgb) {
    var [r, g, b, a] = rgb;
    return [clamp(r, 0, 255), clamp(g, 0, 255), clamp(b, 0, 255)].concat(a == void 0 ? [] : [clamp(a, 0, 100)]);
}

function add_color(a, b) {
    return [a[0]+b[0], a[1]+b[1], a[2]+b[2]].concat(a[3] || b[3] ? [(a[3] ? a[3] : 0) + (b[3] ? b[3] : 0)] : []);
}

function add_hsl(a, b) {
    return saturate_hsl(add_color(a,b));
}

function add_rgb(a, b) {
    return saturate_rgb(add_color(a,b));
}

function css_from_hsl(hsl) {
    var [h, s, l, a] = hsl;
    return a == void 0 ? `hsl(${h},${s}%,${l}%)` : `hsla(${h},${s}%,${l}%,${a}%)`;
}

function css_from_rgb(rgb) {
    var [r, g, b, a] = rgb;
    return a == void 0 ? `rgb(${r},${g},${b})` : `rgba(${r},${g},${b},${a}%)`;
}

function hex_from_rgb(rgb) {
    var [r, g, b] = rgb;
    return sprintf("#%02x%02x%02x", r, g, b);
}

function hex_from_hsl(hsl) {
    return hex_from_rgb(rgb_from_hsl(hsl));
}


module.exports = {
    rgb_from_hsl: rgb_from_hsl,
    hsl_from_rgb: hsl_from_rgb,
    rgb_from_hex: rgb_from_hex,
    hsl_from_hex: hsl_from_hex,
    css_from_rgb: css_from_rgb,
    css_from_hsl: css_from_hsl,
    hex_from_rgb: hex_from_rgb,
    hex_from_hsl: hex_from_hsl,
    add_hsl: add_hsl,
    add_rgb: add_rgb
}
